export default __webpack_public_path__ + "static/media/Banner1.c37250dd.png";